export const blankBook = {
  favorite: false,
  kind: "",
  id: "",
  etag: "",
  selfLink: "",
  volumeInfo: {
    title: "",
    authors: "",
    publisher: "",
    publishedDate: "",
    description: "",
    industryIdentifiers: [
      {
        type: "",
        identifier: "",
      },
      {
        type: "",
        identifier: "",
      },
    ],
    readingModes: {
      text: true,
      image: false,
    },
    pageCount: 584,
    printType: "",
    categories: [""],
    maturityRating: "",
    allowAnonLogging: true,
    contentVersion: "",
    panelizationSummary: {
      containsEpubBubbles: false,
      containsImageBubbles: false,
    },
    imageLinks: {
      smallThumbnail: "",
      thumbnail: "",
    },
    language: "",
    previewLink: "",
    infoLink: "",
    canonicalVolumeLink: "",
  },
  saleInfo: {
    country: "",
    saleability: "",
    isEbook: true,
    listPrice: {
      amount: "",
      currencyCode: "",
    },
    retailPrice: {
      amount: 47.4,
      currencyCode: "",
    },
    buyLink: "",
    offers: [
      {
        finskyOfferType: 1,
        listPrice: {
          amountInMicros: 49900000,
          currencyCode: "",
        },
        retailPrice: {
          amountInMicros: 47400000,
          currencyCode: "",
        },
        giftable: true,
      },
    ],
  },
  accessInfo: {
    country: "",
    viewability: "",
    embeddable: true,
    publicDomain: false,
    textToSpeechPermission: "",
    epub: {
      isAvailable: true,
      acsTokenLink: "",
    },
    pdf: {
      isAvailable: false,
    },
    webReaderLink: "",
    accessViewStatus: "",
    quoteSharingAllowed: false,
  },
  searchInfo: {
    textSnippet: "",
  },
};
